import { render } from "./FormDeliveryPriceCalc.vue?vue&type=template&id=62b6c8c6"
import script from "./FormDeliveryPriceCalc.vue?vue&type=script&lang=js"
export * from "./FormDeliveryPriceCalc.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataForm/FormDeliveryPriceCalc.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62b6c8c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62b6c8c6', __exports__)) {
    console.log('reload')
    api.reload('62b6c8c6', __exports__)
  }
  
  module.hot.accept("./FormDeliveryPriceCalc.vue?vue&type=template&id=62b6c8c6", () => {
    console.log('re-render')
    api.rerender('62b6c8c6', render)
  })

}


export default __exports__